// This is the invoice maker backend api endpoint managed by us.
export const API_ENDPOINT = process.env.REACT_APP_API_ENDPOINT;
